// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.beneficiary-card {
  padding: 48px 24px;
  background-color: #fff;
  color: #1b1b1e;
  font-size: 16px;
  font-weight: 600;
}
.beneficiary-card-header {
  display: flex;
  flex-direction: column;
  gap: 48px;
  align-items: start;
}
.input-gray {
  background-color: #f1f3f7;
  border-radius: 16px;
  padding: 24px;
  border: none;
  font-size: 16px;
  width: 600px;
}
.input-gray:active,
.input-gray:focus {
  border: none;
  border-color: var(--primary);
}
.add-beneficiary-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.add-beneficiary-btn {
  margin-top: 20px;
  align-self: start;
}
.input-form {
  font-size: 13px;
  padding: 13px 24px;
  color: #7e898b;
  background-color: #f2f3f7;
  border-radius: 4px;
  border: none;
  font-weight: 400;
}
.input-form:active,
.input-form:focus {
  border: none;
  border-color: var(--primary);
}
.input-form-container {
  display: grid;
  gap: 1px;
  position: relative;
}
.input-form-container label {
  font-size: 14px;
  display: flex;
  align-items: flex-end;
  gap: 8px;
}
.add-beneficiary-form-header {
  display: flex;
  gap: 20px;
  flex-direction: column;
  align-items: start;
  margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/beneficiaries/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".beneficiary-card {\r\n  padding: 48px 24px;\r\n  background-color: #fff;\r\n  color: #1b1b1e;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n}\r\n.beneficiary-card-header {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 48px;\r\n  align-items: start;\r\n}\r\n.input-gray {\r\n  background-color: #f1f3f7;\r\n  border-radius: 16px;\r\n  padding: 24px;\r\n  border: none;\r\n  font-size: 16px;\r\n  width: 600px;\r\n}\r\n.input-gray:active,\r\n.input-gray:focus {\r\n  border: none;\r\n  border-color: var(--primary);\r\n}\r\n.add-beneficiary-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n.add-beneficiary-btn {\r\n  margin-top: 20px;\r\n  align-self: start;\r\n}\r\n.input-form {\r\n  font-size: 13px;\r\n  padding: 13px 24px;\r\n  color: #7e898b;\r\n  background-color: #f2f3f7;\r\n  border-radius: 4px;\r\n  border: none;\r\n  font-weight: 400;\r\n}\r\n.input-form:active,\r\n.input-form:focus {\r\n  border: none;\r\n  border-color: var(--primary);\r\n}\r\n.input-form-container {\r\n  display: grid;\r\n  gap: 1px;\r\n  position: relative;\r\n}\r\n.input-form-container label {\r\n  font-size: 14px;\r\n  display: flex;\r\n  align-items: flex-end;\r\n  gap: 8px;\r\n}\r\n.add-beneficiary-form-header {\r\n  display: flex;\r\n  gap: 20px;\r\n  flex-direction: column;\r\n  align-items: start;\r\n  margin-bottom: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
